import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { useUserStore } from '@/stores/user';
import i18n from '@/i18n';

// 在路由创建前捕获并保存OAuth参数
try {
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  const state = urlParams.get('state');
  sessionStorage.removeItem('oauth_code');
  sessionStorage.removeItem('oauth_state');
  if (code && state) {
    //console.log('路由初始化前捕获OAuth参数: code=', code, 'state=', state);
    sessionStorage.setItem('oauth_code', code);
    sessionStorage.setItem('oauth_state', state);
  }
} catch (e) {
  console.error('保存OAuth参数失败:', e);
}

const publicRoutes: Array<RouteRecordRaw> = [

];

const authRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: { requiresAuth: false, titleKey: 'Router.home', keepAlive: true } 
  },
  {
    path: '/terms',
    name: 'Terms',
    component: () => import('@/views/Terms.vue'),
    meta: { requiresAuth: false, titleKey: 'Router.terms', keepAlive: true }
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('@/views/Terms.vue'),
    meta: { requiresAuth: false, titleKey: 'Router.privacy', keepAlive: true }
  },
  {
    path: '/cookie',
    name: 'Cookie',
    component: () => import('@/views/Terms.vue'),
    meta: { requiresAuth: false, titleKey: 'Router.cookie', keepAlive: true }
  },
  {
    path: '/payment/success',
    name: 'PaymentSuccess',
    component: () => import('@/views/PaymentCallback.vue'),
    meta: {
      requiresAuth: false,
      titleKey: 'PaymentSuccess.title',
      keepAlive: true
    }
  },
  {
    path: '/user',
    name: 'User',
    component: () => import('@/views/UserDetail.vue'),
    meta: { requiresAuth: true, titleKey: 'Router.user', keepAlive: true }
  }
];

const errorRoutes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
];

const routes: Array<RouteRecordRaw> = [
  ...publicRoutes,
  ...authRoutes,
  ...errorRoutes
];

const router = createRouter({
  history: createWebHistory(),  
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
});

router.beforeEach(async (to, from, next) => {

  const titleKey = to.meta.titleKey as string;
  if (titleKey) {
    const pageName = i18n.global.t(titleKey);
    const appName = i18n.global.t('Nav.title');
    document.title = `${pageName} - ${appName}`;
  } else {
    document.title = i18n.global.t('Nav.title');
  }
  
  const userStore = useUserStore();
  
  if (to.meta.requiresAuth && !userStore.isAuthenticated) {
    localStorage.setItem('login_redirect', to.fullPath);
    next({ path: '/' });
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  // 访问统计逻辑可以在这里实现
});

export default router; 